import { ProgramTermsArray } from '@/queries/academic_terms/schema'
import { isAfter, isBefore } from 'date-fns'
import z from 'zod'
import { dateToYYYYMMDD } from '../../../utils'

export const AwardDatesSchema = (
  awardDistributionPeriods: ProgramTermsArray,
  selectedAwardPeriodId: number
) => {
  return z
    .object({
      startDate: z.date(),
      endDate: z.date(),
    })
    .superRefine((data, ctx) => {
      const currentQuarterIndex = awardDistributionPeriods.findIndex(
        ({ id }) => id === selectedAwardPeriodId
      )

      const previousTerm = awardDistributionPeriods[currentQuarterIndex - 1]

      if (previousTerm && previousTerm.awarding_period_end_date) {
        const previousQuarterEndDate = new Date(
          previousTerm.awarding_period_end_date
        )

        const isValidStartDate = isAfter(data.startDate, previousQuarterEndDate)

        if (!isValidStartDate) {
          ctx.addIssue({
            path: ['startDate'],
            code: z.ZodIssueCode.custom,
            message: `Start Date can't overlap ${previousTerm.name}'s end date (${dateToYYYYMMDD(previousTerm.awarding_period_end_date)})`,
          })
        }
      }

      // the end date can't overlap the the next quarter's start date

      const nextTerm = awardDistributionPeriods[currentQuarterIndex + 1]
      if (nextTerm && nextTerm.awarding_period_start_date) {
        const nextQuarterStartDate = new Date(
          nextTerm.awarding_period_start_date
        )

        const isValidEndDate = isBefore(data.endDate, nextQuarterStartDate)

        if (!isValidEndDate) {
          ctx.addIssue({
            path: ['endDate'],
            code: z.ZodIssueCode.custom,
            message: `End Date can't overlap ${nextTerm.name}'s start date (${dateToYYYYMMDD(nextTerm.awarding_period_start_date)})`,
          })
        }
      }

      if (data.startDate && data.endDate) {
        if (data.startDate > data.endDate) {
          ctx.addIssue({
            path: ['endDate'],
            code: z.ZodIssueCode.custom,
            message: 'End date must come after start date',
          })
        }
      }
    })
}
